// TODO // date functions and other multi-use functions
import axios from "axios"
const env = process.env.REACT_APP_ENVIRONMENT;

const handleRoute = () => {
  if (env === 'production') {
    return "https://advancedair-api.intelisys.ca/RESTv1/";
  } else {
    return "https://advancedair-api.intelisystraining.ca/RESTv1/";
  }
};

const formatAxiosOptions = (rloc, resKey, ameliaToken) => {
  let url = resKey
    ? `reservations/${encodeURIComponent(resKey)}`
    : `reservations?reservationLocator=${rloc}`
   
  const baseURL = handleRoute()
  return {
    
    baseURL,
    url,
    method: 'get',
    headers: { 'Authorization': `Bearer ${ameliaToken}` }
  }
}




// Get all reservation data in the loadPaxInfo
export const getResInfo = async (rloc, ameliaToken) => {
  try {
    // First: get reservation using RLOC
    
    let reservationKeyRequest = await axios.request(formatAxiosOptions(rloc, '', ameliaToken))
    let key = reservationKeyRequest?.data?.[0]?.key
console.log(':package: Raw response:', reservationKeyRequest.data)
    if (key) {
      // Then: fetch using reservation key
      let reservationRequest = await axios.request(formatAxiosOptions(rloc, key, ameliaToken))
      console.log(":white_check_mark: Reservation found:", reservationRequest.data)

      return reservationRequest.data
    } else {
      throw new Error(`No key returned for rloc ${rloc}. Response: ${JSON.stringify(reservationKeyRequest.data)}`)
    }
  } catch (error) {
    console.log(new Date().toISOString(), `getResInfo ERROR: ${error.message || error}`)
    return false
  }
}